"use strict";const s="fade";exports.fadeClass=s;
//# sourceMappingURL=fadeClass-Co6nOzNJ.js.map
